<div class="dialog-class w652">
  <div class="image-header">
    <img src="assets/images/micetribe.svg" alt="" />
    <img src="assets/images/dtcmlogo.svg" alt="" />
  </div>
  <div class="dtcm-message">
    <h3 style="font-size: 17px">{{ data?.headerText }}</h3>
    <p>{{ data?.messageText }}</p>
  </div>
  <div class="buttons">
    <button class="btn-secondary" (click)="proceed('addFields')">Add fields</button>
    <button class="btn-success" (click)="proceed('gotoPersona')">Go to persona page</button>
    <button class="cancel" (click)="dialogRef.close()">Cancel</button>
  </div>
</div>
